import { render, staticRenderFns } from "./withdrawcash.vue?vue&type=template&id=b8a31fde&scoped=true"
import script from "./withdrawcash.vue?vue&type=script&lang=ts"
export * from "./withdrawcash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a31fde",
  null
  
)

export default component.exports